import { LOADER_STATUS, EMAIL_MASTER_DATA } from "./constants";

export const initialState = {
  loaderStatus: false,
  emailMasterData: [],
};

/* eslint-disable default-case, no-param-reassign */
const emailMasterReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case EMAIL_MASTER_DATA:
      return {
        ...state,
        emailMasterData: action.emailMasterData,
      };
    default:
      return state;
  }
};

export default emailMasterReducer;
